import { armoireLogo, bucketlistersLogo, lepuzzLogo, prepsosLogo, quinceLogo } from "#web/assets";
import { i18nLike } from "#web/services/i18nLike";
import { Box } from "@shopify/polaris";

import * as s from "./SocialProof.css";

const en = {
  title: `<span class="${s.SocialProofTitleHighlight}">Boosting margins </span>for fast growing brands`,
};

export const SocialProof = () => {
  const t = i18nLike(en);
  const logos = [quinceLogo, bucketlistersLogo, lepuzzLogo, prepsosLogo, armoireLogo];

  return (
    <Box paddingBlockStart="800" width="100%">
      <div className={s.SocialProof}>
        <div className={s.SocialProofTitle}>
          <span dangerouslySetInnerHTML={{ __html: t("title") }} />
        </div>
        <div className={s.SocialProofLogos}>
          {logos.map((logo, index) => (
            <div className={s.SocialProofLogoWrapper} key={index}>
              <img className={s.SocialProofLogo} src={logo} />
            </div>
          ))}
        </div>
      </div>
    </Box>
  );
};
